module.exports = __webpack_public_path__ + "static/media/dosa.b0ab3e53.jpg";